module.exports = __webpack_public_path__ + "img/Brand awareness Icon - white.43951cf4.svg";